/** API route map: URLS.Controller.BenefitsContribution */
export const BenefitsContribution = {
      Name: 'BenefitsContribution/',
      SearchBenefitsTire: 'search-benefits-tire',
      SearchBenefitsTireEnrollment: 'search-benefits-tire-enrollment',
      AddContribution: 'add-benefits-contribute',
      GetAllContibution: 'all-benefits-contribute',
      GetSetting: 'get-benefits-setting',
      UpdateSetting: 'update-benefits-setting',
      Update: 'update',
      DeleteContribution: 'delete',
      SearchBenefitsCustomTier: 'search-benefits-custom-tire',
      SearchBenefitsTierTable: 'search-benefits-tire-table',
      SearchBenefitsCustomTierEnrollment: 'search-benefits-custom-tire-enrollment',
      SearchBenefitsTierTableEnrollment: 'search-benefits-tire-table-enrollment',
      GetAllContributions: 'get-all-contributions',
      GetAllContributionsForEnrollment: 'get-all-benefits-contributios-for-enrollment',
      GetAllContributionsForEnrollmentPlans: 'get-all-benefits-contributios-for-enrollment-plans',
      GetAllContributionsForEnrollmentPlansEmployee:
        'get-all-benefits-contributios-for-enrollment-plans-employee',
      GetAllContributionGroups: 'get-all-contribution-groups',
      GetAllCloneContributionGroups: 'get-all-clone-contribution-groups',
      CloneContribution: 'clone-contribution',
      CheckContributionExist: 'contribution-exist',
};
